import {
  CommissionType,
  DurationUnit,
  ICommissionTypeFrontEndModel,
  IDurationUnit,
} from "./types";

export const DATE_FORMATS = {
  frontEnd: "DD.MM.YYYY",
  backEnd: "DD/MM/YYYY",
};

export const COLORS = {
  message: {
    main: "#cc96f1",
    dark: "#bd75ef",
    contrastText: "#ffffff",
  },
};

export const QUERY_KEYS = {
  schoolStudentApplications: "schoolStudentApplications",
  majorsContainingPrograms: "majorsContainingPrograms",
  degrees: "degrees",
  branches: "branches",
  majors: "majors",
  services: "services",
  userAvailableBranches: "userAvailableBranches",
  adminUsersList: "adminUsersList",
  servicesListByProvider: "servicesListByProvider",
  privateClassListForTeacher: "privateClassListForTeacher",
  privateClassSubjects: "privateClassSubjects",
};

export const getDurationUnits: (entityName?: string) => IDurationUnit[] = (
  entityName = "",
) => [
  {
    id: DurationUnit.DAYS,
    name: "Days",
  },
  {
    id: DurationUnit.WEEKS,
    name: "Weeks",
  },
  {
    id: DurationUnit.MONTHS,
    name: "Months",
  },
  {
    id: DurationUnit.YEARS,
    name: "Years",
  },
  {
    id: DurationUnit.FULL,
    name: `Full ${entityName}`,
  },
];

export const getDurationUnitsMap: (entityName: string) => {
  [key: string]: string;
} = (entityName) => ({
  [DurationUnit.DAYS]: "Days",
  [DurationUnit.WEEKS]: "Weeks",
  [DurationUnit.MONTHS]: "Months",
  [DurationUnit.YEARS]: "Years",
  [DurationUnit.FULL]: `Full ${entityName}`,
});

export const COMMISSION_TYPES: ICommissionTypeFrontEndModel[] = [
  {
    id: CommissionType.FIXED,
    name: "Fixed",
  },
  {
    id: CommissionType.PERCENT,
    name: "Percent",
  },
];

export const ENTITY_NAMES = {
  academic: "academic",
  program: "program",
  intake: "intake",
  branch: "branch",
  course: "course",
};

export const HTMLTagRegEx = /(<([^>]+)>)/gi;
